import { render, staticRenderFns } from "./GroupClientCell.vue?vue&type=template&id=3c7b5aec&scoped=true&"
import script from "./GroupClientCell.vue?vue&type=script&lang=js&"
export * from "./GroupClientCell.vue?vue&type=script&lang=js&"
import style0 from "./GroupClientCell.vue?vue&type=style&index=0&id=3c7b5aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b5aec",
  null
  
)

export default component.exports